module.exports = __webpack_public_path__ + "static/templateView-f260d42ed04e90295028b27de5f8b9bd.png";